import React from 'react';
import {Badge, Card, Col, Descriptions, Row, Select, Space, Statistic, Tabs, Tag, Typography} from "antd";
import {convertToJalaliWithFormat, formatDateFull} from "@/lib/utils/date";

import {BookOutlined, DollarOutlined} from '@ant-design/icons';
import {formatPrice} from "@/lib/utils/number";

const {Title, Text, Paragraph} = Typography;
const {Option} = Select;
const {TabPane} = Tabs;

function TopicDetailSection({topicData}) {
    return (
        <div>
            {/* هدر با اطلاعات اصلی */}
            <Card className="mb-6 shadow-lg bg-gradient-to-r from-blue-950/40 to-indigo-950/40 dark:from-blue-950/50 dark:to-indigo-950/50">
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} md={16}>
                        <div className="flex items-center gap-3">
                            <BookOutlined className="text-4xl text-blue-600"/>
                            <div>
                                <Title level={2} className="!mb-1  ">
                                    {topicData?.data?.data?.title}
                                </Title>
                                <Space>
                                    <Tag color="blue"
                                         className="text-sm">{topicData?.data?.data?.group.title}</Tag>
                                    <Tag color="purple"
                                         className="text-sm">کد: {topicData?.data?.data?.code}</Tag>
                                    <Badge status="processing" text="فعال"/>
                                </Space>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} md={8}>
                        <div className=" p-4 rounded-lg shadow">
                            <Statistic
                                title="مبلغ دوره"
                                value={formatPrice(topicData?.data?.data?.price)}
                                prefix={<DollarOutlined className="text-green-600"/>}
                                className="text-center"
                            />
                        </div>
                    </Col>
                </Row>
            </Card>

            {/* اطلاعات اصلی */}
            <Row gutter={[16, 16]} className="mb-6">
                <Col xs={24} lg={12}>
                    <Card title="اطلاعات دوره" className="shadow-md h-full">
                        <Descriptions column={1} bordered size="small">
                            <Descriptions.Item label="شناسه">{topicData?.data?.data?.id}</Descriptions.Item>
                            <Descriptions.Item
                                label="عنوان">{topicData?.data?.data?.title}</Descriptions.Item>
                            <Descriptions.Item
                                label="گروه">{topicData?.data?.data?.group.title}</Descriptions.Item>
                            <Descriptions.Item
                                label="پایه">{topicData?.data?.data?.grade.title}</Descriptions.Item>
                            <Descriptions.Item
                                label="واحد آموزشی">{topicData?.data?.data?.learnunit}</Descriptions.Item>
                            <Descriptions.Item
                                label="کد دوره">{topicData?.data?.data?.code}</Descriptions.Item>
                            <Descriptions.Item label="تاریخ ایجاد">
                                {formatDateFull(topicData?.data?.data?.datecreated)}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>

                <Col xs={24} lg={12}>
                    <Card title="محدودیت سنی و ثبت‌نام" className="shadow-md h-full">
                        <Descriptions column={1} bordered size="small">
                            <Descriptions.Item label="حداقل تاریخ تولد">
                                {convertToJalaliWithFormat(topicData?.data?.data?.minagedate)}
                            </Descriptions.Item>
                            <Descriptions.Item label="حداکثر تاریخ تولد">
                                {convertToJalaliWithFormat(topicData?.data?.data?.maxagedate)}
                            </Descriptions.Item>
                            <Descriptions.Item label="وضعیت ثبت‌نام">
                                <Badge status={topicData?.data?.data?.signup ? 'success' : 'error'}
                                       text={topicData?.data?.data?.signup ? 'باز' : 'بسته'}/>
                            </Descriptions.Item>
                            <Descriptions.Item label="وضعیت اقساط">
                                <Badge status={topicData?.data?.data?.installment ? 'success' : 'default'}
                                       text={topicData?.data?.data?.installment ? 'فعال' : 'غیرفعال'}/>
                            </Descriptions.Item>
                            {topicData?.data?.data?.payerid && (
                                <Descriptions.Item label="شناسه پرداخت‌کننده">
                                    <Text code>{topicData?.data?.data?.payerid}</Text>
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </Card>
                </Col>
            </Row>

        </div>
    );
}

export default TopicDetailSection;